module.exports = __webpack_public_path__ + "static/media/brand-story-wap7.4d7e3820.jpg";